import _ from "lodash";
import { useCallback } from "react";
import { useRemoteDataMutation } from "src/hooks/useRemoteDataMutation";
import * as GQL from "src/types/graphql";
import { UPDATE_MESSAGE_TEMPLATES } from "../../graphql/mutations";
import { GET_MESSAGE_TEMPLATE_TYPES } from "../../graphql/queries";
import { transformFormValuesToMutationVariables } from "../helpers";
import { Action } from "../processor";
import { ListMessageTemplatesFormType } from "../schemas";

export const useSaveListChanges = (
  formTemplateId: string,
  isRankingEnabled: boolean,
  dispatch: ((action: Action) => void) | undefined
) => {
  const [updateMessageTemplates] = useRemoteDataMutation<
    GQL.UpdateMessageTemplates,
    GQL.UpdateMessageTemplatesVariables
  >(UPDATE_MESSAGE_TEMPLATES);

  const updateTemplateIds = useCallback(
    (
      returning: Array<{
        type: GQL.message_template_type_enum;
        school_id: string | null;
        id: string;
      }>,
      values: ListMessageTemplatesFormType
    ) => {
      for (const row of returning) {
        const templatesBySpecificity = values[row.type];
        if (templatesBySpecificity) {
          if (row.school_id) {
            const schoolTemplate =
              templatesBySpecificity.schoolSpecific[row.school_id];
            if (schoolTemplate) schoolTemplate.id = row.id;
          } else {
            if (templatesBySpecificity.standard) {
              templatesBySpecificity.standard.id = row.id;
            }
          }
        }
      }
    },
    []
  );

  const saveListChanges = useCallback(
    async (draft: ListMessageTemplatesFormType) => {
      const values = _.omit(draft, "isDraft");

      const mutationVariables = transformFormValuesToMutationVariables(
        values,
        isRankingEnabled
      );

      const result = await updateMessageTemplates({
        variables: mutationVariables,
        refetchQueries: [GET_MESSAGE_TEMPLATE_TYPES],
      });

      const returning = result.data?.insert_message_template?.returning;
      if (returning && returning.length > 0) {
        updateTemplateIds(returning, values);
      }

      if (dispatch) {
        dispatch({
          type: "Refresh",
          initialValues: { listMessages: values },
          formTemplateId,
        });
      }
    },
    [
      updateMessageTemplates,
      dispatch,
      formTemplateId,
      isRankingEnabled,
      updateTemplateIds,
    ]
  );

  return saveListChanges;
};
